import React, { useMemo } from 'react';
import utils from 'utils';
import DropDown from 'components/Input/dropdown/Dropdown';
import { Props } from '..';

const container = document.getElementById('react-select-portal');
const Select = (props: Props) => {
  const column = props;
  const { filterValue, setFilter, id: accessor, preFilteredRows, selectFilterOptions } = column;
  const options = useMemo(() => {
    if (!selectFilterOptions) return utils.table.buildOptionsByRowsWithCount(preFilteredRows, accessor);
    return selectFilterOptions;
  }, [preFilteredRows, accessor, selectFilterOptions]);

  const value = useMemo(() => {
    if (filterValue === null || filterValue === undefined || filterValue === '') {
      return [];
    }
    // eslint-disable-next-line eqeqeq
    return options.filter(({ value }) => value == filterValue) || [];
  }, [options, filterValue]);

  return (
    <DropDown
      id={`select-dropdown-${accessor}`}
      small
      isClearable
      value={value}
      onChange={(option) => {
        setFilter(`${option?.value ?? ''}`);
      }}
      options={options}
      menuWidth="fit-content"
      closeMenuOnScroll={(e) => {
        if (container?.contains(e.target as Node)) return false;
        return true;
      }}
    />
  );
};

export default Select;
